import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=3d3eba50"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=3d3eba50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports